/* eslint-disable no-unused-expressions */

import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// api
import { getPatientLastWeekFromHearro, getPatientTrainAmountFromHearro, getPatientTrainTotalResultFromHearro, getPatientTrainWeeklyResultFromHearro } from '../../../../services/apis/hearro/train';


function HearroResult() {
    const { pid } = useParams();
	const [perfectCount, setPerfectCount] = useState(0);
	const [trainAmount, setTrainAmount] = useState({ h: 0, m: 0 });

    const [lastWeek, setLastWeek] = useState(0);
	const [resultWeek, setResultWeek] = useState(0);

	const [weeklyData, setWeeklyData] = useState([]);
	const weekText = ['일', '월', '화', '수', '목', '금', '토'];
	const [weeklyMax, setWeeklyMax] = useState(0);

	const [totalResultData, setTotalResultData] = useState([]);

    // GET 누적 훈련 시간 & 다 맞춘 훈련 from API
	async function getPatientTrainDataFromAPI() {
        try{
            const res = await getPatientTrainAmountFromHearro({ pid });
            if (parseInt(res.status / 200, 10) === 1) {
                if (res.data.perfectCount) {
                    setPerfectCount(res.data.perfectCount);
                }else{
                    setPerfectCount(0);
                }
                if (res.data.trainAmount) {
                    const trainAmountArr = res.data.trainAmount.split(/H|M/);
                    setTrainAmount({ h: trainAmountArr[0], m: trainAmountArr[1] });
                }else{
                    setTrainAmount({ h: 0, m: 0 });
                }
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setPerfectCount(0);
            setTrainAmount({ h: 0, m: 0 });
        }
	}

    // GET 환자의 최근 주차 from API
    async function getLastWeekFromAPI() {
        try {
            const res = await getPatientLastWeekFromHearro({ pid });
            if(parseInt(res.status/200,10)===1){
                if(res.data){
                    setLastWeek(res.data);
                    setResultWeek(res.data);
                }else{
                    setLastWeek(1);
                    setResultWeek(1);
                }                
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setLastWeek(1);
            setResultWeek(1);
        }
    }

    // GET 주차별 결과 from API
	async function getWeeklyResultFromAPI() {
        try{
            const res = await getPatientTrainWeeklyResultFromHearro({ pid, week: resultWeek });
            if(parseInt(res.status/200,10)===1){
                setWeeklyData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setWeeklyData([]);
        }
	}

    // GET 연습 결과 from API
	async function getTotalResultFromAPI() {
        try{
            const res = await getPatientTrainTotalResultFromHearro({ pid, week: resultWeek });
            if (parseInt(res.status / 200, 10) === 1) {
                setTotalResultData(res.data);
            }else{
                throw new Error();
            }
        }catch(err){
            console.error(err);
            setTotalResultData([]);
        }
		
	}

    async function getPrevWeeklyResult() {
		setResultWeek(resultWeek - 1);
	}

	async function getNextWeeklyResult() {
		setResultWeek(resultWeek + 1);
	}


	useEffect(() => {
        getLastWeekFromAPI();
		getPatientTrainDataFromAPI();
	}, []);

    useEffect(()=>{
        if(resultWeek){
            getWeeklyResultFromAPI();
            getTotalResultFromAPI();
        }		
    },[resultWeek])

	useEffect(() => {
		if (weeklyData.length === 0) {
			setWeeklyMax(0);
		} else {
			setWeeklyMax(Math.max(...weeklyData.map(item => item.dailyAmount)));
		}
	}, [weeklyData]);

	return (
        <div className="patientResult__analysisArea">
            <div className="analysisReport">
                <span className="analysisReport__title">연습 시간</span>
                <div className="analysisReport__time">
                    <div className="textContent">
                        <div className="textContent__item bordered">
                            <span>누적 훈련 시간</span>
                            <span>
                                {trainAmount.h}시간 {trainAmount.m}분
                            </span>
                        </div>
                        <div className="textContent__item bordered">
                            <span>다 맞춘 훈련</span>
                            <span>{perfectCount} 개</span>
                        </div>
                    </div>
                    <div className="graphContent bordered">
                        <div className="graphContent__header">
                            <div className="description">
                                <hr />
                                <span>권장 사용 시간</span>
                            </div>
                            <div className='graph_box_date_wrapper'>
                                <button
                                    onClick={() => (resultWeek > 1 ? getPrevWeeklyResult() : null)}
                                    style={{ cursor: resultWeek > 1 ? 'pointer' : 'default' }}
                                >&lt;</button>
                                <span>{resultWeek}주차</span>
                                <button
                                    onClick={() => {
                                        resultWeek < lastWeek
                                            ? getNextWeeklyResult()
                                            : null;
                                    }}
                                    style={{
                                        cursor:
                                            resultWeek < lastWeek
                                                ? 'pointer'
                                                : 'default',
                                    }}
                                >&gt;</button>
                            </div>
                        </div>
                        <div className="graphContent__body">
                            <div className="graphLabel">
                                <span
                                    style={{
                                        bottom: weeklyMax > 30 ? `calc((30 / ${weeklyMax}) * 100%)` : '100%',
                                        color: '#174a84', fontWeight: 'bold',
                                    }}
                                >
                                    30 분
                                </span>
                                <span style={{ bottom: '0' }}>0 분</span>
                            </div>
                            <div className="graphBody">
                                <div className="graph">
                                    {weeklyData.map((item, idx) => (
                                        <div key={idx} className="graph__wrapper" style={{ width: 'calc(100% / 7)' }}>
                                            <div
                                                className="graph__item"
                                                style={{
                                                    height:
                                                        weeklyMax > 30
                                                            ? `calc(100% * (${item.dailyAmount} / ${weeklyMax}))`
                                                            : `calc(100% * (${item.dailyAmount} / 30))`,
                                                }}
                                            />
                                        </div>
                                    ))}
                                    <hr
                                        className="graph__division"
                                        style={{
                                            bottom:
                                                weeklyMax > 30
                                                    ? `calc(( 30 / ${weeklyMax}) * 100%)`
                                                    : '100%',
                                        }}
                                    />
                                </div>
                                <div className="label">
                                    {weeklyData.map((item, idx) => (
                                        <div key={idx} style={{ width: 'calc(100% / 7)' }}>
                                            {parseInt(item.date.substring(4, 6), 10)}/
                                            {parseInt(item.date.substring(6, 8), 10)}
                                            <br />
                                            {
                                                weekText[
                                                    new Date(
                                                        item.date.substring(0, 4),
                                                        item.date.substring(4, 6) - 1,
                                                        item.date.substring(6, 8),
                                                    ).getDay()
                                                ]
                                            }
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="analysisReport">
                <span className="analysisReport__title">연습 결과</span>
                <div className="analysisReport__result">
                    <div className="result__contents">
                        {totalResultData.map((item, idx) => (
                            <div key={idx} className="result__contents__item">
                                <span className="title">{item.trainName}</span>
                                <div className="graph">
                                    <hr className="line" />
                                    <div
                                        className="average"
                                        style={{ width: `${item.avgAccuracy}%` }}
                                    />
                                    <div
                                        className="score"
                                        style={{ width: `${item.patientAccuracy}%` }}
                                    />
                                </div>
                                <span className="score">{item.patientAccuracy} / 100</span>
                            </div>
                        ))}
                    </div>
                    <div className="result__description">
                        <div className="color" style={{ backgroundColor: '#aed0db' }} />
                        <span>나의 평균 점수</span>
                        <div className="color" style={{ backgroundColor: '#ababab' }} />
                        <span>평균 점수</span>
                    </div>
                </div>
            </div>
        </div>
	);
}

export default HearroResult;